import en from './locale/en';
import pt from './locale/pt';
import zh_CN from './locale/zh_CN';
import zh_TW from './locale/zh_TW';

export default {
  en,
  pt,
  zh_CN,
  zh_TW,
};
